/* eslint-disable import/no-extraneous-dependencies */
// import sum from 'lodash/sum';
// import uniq from 'lodash/uniq';
// import uniqBy from 'lodash/uniqBy';
import { createSlice } from '@reduxjs/toolkit';
import qs from "qs"; // optional, for cleaner query string building
// utils
import { axiosInstance } from '../../utils/axiosInstance';
const url_Backend = process.env.BACKEND_URL;
const RSL_BACKEND_URL = process.env.RSL_BACKEND_URL;
const RSL_ADMIN_BACKEND_URL = process.env.RSL_ADMIN_BACKEND_URL;
const url = 'https://promo.royalsmartlifestyle.com';
// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  userDetail: undefined,
  socialSignupResponse: undefined,
  checkOrderStatusRes: undefined,
  couponDetails: undefined,
  fleetSafariState: [],
  fleetCarsState: [],
  bookingOrEnquiryRes: undefined,
  getOurFleetSuccessRes: undefined,
  getBlogListSuccessRes: undefined,
  getRelatedProductsRes: undefined,
  serviceBannerList: [],
  bannerList: [],
  serviceBannerVideoList: [],
  popularListEach: []
};

const slice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
      state.userDetail = undefined;
      state.couponDetails = undefined;
      state.socialSignupResponse = undefined;
      state.checkOrderStatusRes = undefined;
      state.fleetSafariState = [];
      state.fleetCarsState = [];
      state.bookingOrEnquiryRes = undefined;
      // state.getOurFleetSuccessRes = undefined;
      // state.serviceBannerList = [];
      // state.bannerList = [];
      // state.serviceBannerList = [];
      // state.backgroundImage = [];
      state.careerList = [];
      // state.bannerList = [];
      state.InvestorList = [];
      state.getOurFleetsList = [];
      state.partnerLogo = [];
      state.serviceList = [];
      state.activityList = [];
      state.popularList = [];
      state.carRentList = [];
      // state.popularAttractionList = [];
      state.careerApply = [];
      state.subsApply = [];
      state.fleetState = [];
      state.fleetBusState = [];
      state.fleetSafariState = [];
      // state.jobDetails = [];
      state.fleetCarsState = [];
      state.bookingOrEnquiryRes = [];
      // state.getOurFleetSuccessRes = [];

    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    checkCouponElgibleSuccess(state, action) {
      state.isLoading = false;
      state.couponDetails = action.payload;
    },
    bannerBackgroundSuccess(state, action) {
      state.isLoading = false;
      state.backgroundImage = action.payload;
    },
    getCareerListSuccess(state, action) {
      state.isLoading = false;
      state.careerList = action.payload;
    },
    getOffersListSuccess(state, action) {
      state.isLoading = false;
      state.bannerList = action.payload;
    },
    getServiceBannerListSuccess(state, action) {
      state.isLoading = false;
      state.serviceBannerList = action.payload;
    },
    getServiceBannersListSuccess(state, action) {
      state.isLoading = false;
      state.serviceBannerVideoList = action.payload;
    },
    getBannerImageListSuccess(state, action) {
      state.isLoading = false;
      state.bannerImageList = action.payload;
    },
    getInvestorListSuccess(state, action) {
      state.isLoading = false;
      state.InvestorList = action.payload;
    },
    getOurFleetsListSuccess(state, action) {
      state.isLoading = false;
      state.getOurFleetsList = action.payload;
    },
    getPartnerListSuccess(state, action) {
      state.isLoading = false;
      state.partnerLogo = action.payload;
    },
    getServiceListSuccess(state, action) {
      state.isLoading = false;
      state.serviceList = action.payload;
    },
    getActivitiesListSuccess(state, action) {
      state.isLoading = false;
      state.activityList = action.payload;
    },
    getPopularsListSuccess(state, action) {
      state.isLoading = false;
      state.popularList = action.payload;
    },
    getPopularsListEachSuccess(state, action) {
      state.isLoading = false;
      state.popularListEach = action.payload;
    },
    getCarRentSuccess(state, action) {
      state.isLoading = false;
      state.carRentList = action.payload;
    },
    getPopularAttractionSuccess(state, action) {
      state.isLoading = false;
      state.popularAttractionList = action.payload;
    },
    careerApplySuccess(state, action) {
      state.isLoading = false;
      state.careerApply = action.payload;
    },
    cancelRequestSuccess(state, action) {
      state.isLoading = false;
      state.cancelAccepted = action.payload;
    },
    subscribeSuccess(state, action) {
      state.isLoading = false;
      state.subsApply = action.payload;
    },
    fleetCarSuccess(state, action) {
      state.isLoading = false;
      state.fleetState = action.payload;
    },
    fleetBusSuccess(state, action) {
      state.isLoading = false;
      state.fleetBusState = action.payload;
    },
    fleetSafariSuccess(state, action) {
      state.isLoading = false;
      state.fleetSafariState = action.payload;
    },
    getJobDetailsSuccess(state, action) {
      state.isLoading = false;
      state.jobDetails = action.payload;
    },
    fleetCarsSuccess(state, action) {
      state.isLoading = false;
      state.fleetCarsState = action.payload;
    },
    getBookingOrEnquirySuccess(state, action) {
      state.isLoading = false;
      state.bookingOrEnquiryRes = action.payload;
    },
    getOurFleetSuccess(state, action) {
      state.isLoading = false;
      state.getOurFleetSuccessRes = action.payload;
    },
    getBlogListSuccess(state, action) {
      state.isLoading = false;
      state.getBlogListSuccessRes = action.payload;
    },
    getRelatedProductsSuccess(state, action) {
      state.isLoading = false;
      state.getRelatedProductsRes = action.payload;
    },
    getOurServiceListSuccess(state, action) {
      state.isLoading = false;
      state.getOurServiceListRes = action.payload;
    },
    getPackageListSuccess(state, action) {
      state.isLoading = false;
      state.getPackageListRes = action.payload;
    },
    getChauffeurEnquirySuccess(state, action) {
      state.isLoading = false;
      state.chauffeurEnquiryRes = action.payload;
    },
    getInvestmentEnquirySuccess(state, action) {
      state.isLoading = false;
      state.investmentEnquiryRes = action.payload;
    },
    getOurFleetsListNewSuccess(state, action) {
      state.isLoading = false;
      state.ourFleetsRes = action.payload;
    },
    getPrivateJetListSuccess(state, action) {
      state.isLoading = false;
      state.privateJetRes = action.payload;
    },
    getPrivateJetListNewSuccess(state, action) {
      state.isLoading = false;
      state.privateJetNewRes = action.payload;
    },
    getPrivateJetAddSuccess(state, action) {
      state.isLoading = false;
      state.privateJetAddRes = action.payload;
    },
    getBookARidePageSuccess(state, action) {
      state.isLoading = false;
      state.bookingRidePageRes = action.payload;
    },
    getPopularsForAllServiceSuccess(state, action) {
      state.isLoading = false;
      state.getgetPopularsForAllServiceRes = action.payload;
    },
    getActiveSubscripitonPlanSuccess(state, action) {
      state.isLoading = false;
      state.activeSubscriptionsData = action.payload;
    },
    getAllCarModelsSuccess(state, action) {
      state.isLoading = false;
      state.allCarModelData = action.payload;
    },
    getTripFareSuccess(state, action) {
      state.isLoading = false;
      state.tripFare = action.payload;
    },
    getLocationValidationSuccess(state, action) {
      state.isLoading = false;
      state.locationValidationData = action.payload;
    },
    getCreateEnquirySuccess(state, action) {
      state.isLoading = false;
      state.createEnquiryRes = action.payload;
    },
    getActivitiesBlogsListSuccess(state, action) {
      state.isLoading = false;
      state.activityBlogsList = action.payload;
    },
    getPackageCategoriesListSuccess(state, action) {
      state.isLoading = false;
      state.packageCategoryList = action.payload;
    },
    getPackagePopularListSuccess(state, action) {
      state.isLoading = false;
      state.packagePopularList = action.payload;
    },
    getFutureBookingListSuccess(state, action) {
      state.isLoading = false;
      state.futureBookingList = action.payload;
    },
    getFutureTripUpdateSuccess(state, action) {
      state.isLoading = false;
      state.tripUpdateRes = action.payload;
    },
    getTrustedPartnersSuccess(state, action) {
      state.isLoading = false;
      state.trustesPartnersRes = action.payload;
    },
    getTopActivitesSuccess(state, action) {
      state.isLoading = false;
      state.topActivitesRes = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  getCart,
  addToCart,
  resetCart,
  gotoStep,
  backStep,
  nextStep,
  deleteCart,
  createBilling,
  applyShipping,
  applyDiscount,
  increaseQuantity,
  decreaseQuantity,
} = slice.actions;

// ----------------------------------------------------------------------

//USER GET PROFILE

// export function checkCouponElgible(obj) {
//   return async (dispatch) => {
//     dispatch(slice.actions.startLoading());
//     try {
//       const response = await axiosInstance.post(
//         `${url}/promo-codes/check`,
//         obj
//       );
//       dispatch(slice.actions.checkCouponElgibleSuccess(response.data));
//     } catch (error) {
//       console.error(error);
//       dispatch(slice.actions.hasError(error));
//     }
//   };
// }
export function checkCouponElgible(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${RSL_BACKEND_URL}/trip/checkAndApplyPromoCode`,
        obj
      );
      dispatch(slice.actions.checkCouponElgibleSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function bannerBackground(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${url_Backend}/common/getBannerImage`,
        obj
      );
      dispatch(slice.actions.bannerBackgroundSuccess(response.data.responseData));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getOffersList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.get(`${url_Backend}/common/listServiceOffers`,);
      dispatch(
        slice.actions.getOffersListSuccess(response.data.responseData)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getServiceBannerList(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url_Backend}/common/listServiceBannerImage`, obj);
      dispatch(
        slice.actions.getServiceBannerListSuccess(response.data.responseData)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getServiceBannersList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.get(`${url_Backend}/common/listServiceBanners`);
      dispatch(
        slice.actions.getServiceBannersListSuccess(response.data.responseData)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}


export function getBookingOrEnquiry() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.get(`${url_Backend}/taxi/getBookingOrEnquiryFlow`,);
      dispatch(
        slice.actions.getBookingOrEnquirySuccess(response.data.responseData)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function submitCancelRequest(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${url_Backend}/booking/cancelRequest`,
        obj
      );
      dispatch(slice.actions.cancelRequestSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getInvestorList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.get(`${url_Backend}/common/listInvestorImage`,);
      dispatch(
        slice.actions.getInvestorListSuccess(response.data.responseData)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getOurFleetList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.get(`${url_Backend}/common/listOurFleet`,);
      dispatch(
        slice.actions.getOurFleetsListSuccess(response.data.responseData)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getCareerList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.get(`${url_Backend}/common/jobList`,);
      dispatch(
        slice.actions.getCareerListSuccess(response.data.responseData)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getCareerApply(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${url_Backend}/common/applyJob`,
        obj
      );
      dispatch(slice.actions.careerApplySuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getSubscribe(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${url_Backend}/common/subscribe`,
        obj
      );
      dispatch(slice.actions.subscribeSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getFleetCar(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${url_Backend}/api/listCar`,
        obj
      );
      dispatch(slice.actions.fleetCarSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getFleetBus(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${url_Backend}/bus/busFleetsList`,
        obj
      );
      dispatch(slice.actions.fleetBusSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getFleetSafari(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${url_Backend}/safari/fleetList`,
        obj
      );
      dispatch(slice.actions.fleetSafariSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getJobDetails(jobId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${url_Backend}/common/jobDetails`,
        jobId
      );
      dispatch(slice.actions.getJobDetailsSuccess(response.data.responseData));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPartnerLogo() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url_Backend}/blog/partnersList`,);
      dispatch(
        slice.actions.getPartnerListSuccess(response.data)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}


export function getServiceList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url_Backend}/api/listServicesNew`,);
      dispatch(
        slice.actions.getServiceListSuccess(response.data)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getBlogList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url_Backend}/blog/blogList`,);
      dispatch(
        slice.actions.getBlogListSuccess(response.data)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}


export function getActivitiesListServices() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url_Backend}/activity/listServices`,);

      dispatch(
        slice.actions.getActivitiesListSuccess(response.data)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}


export function getPopularsListForAllServices() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url_Backend}/common/popularAttractionForAllServices`);

      dispatch(
        slice.actions.getPopularsForAllServiceSuccess(response.data)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getPopularsListServices(serviceType = 6) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url_Backend}/common/popularAttraction`, {
        serviceType: serviceType
      });

      dispatch(
        slice.actions.getPopularsListSuccess(response.data)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPopularsListServicesEach(serviceType = 6) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url_Backend}/common/popularAttraction`, {
        serviceType: serviceType
      });

      dispatch(slice.actions.getPopularsListEachSuccess(response.data));

      // ✅ return data to the caller
      return { payload: response.data, success: true };
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
      return { error, success: false }; // ✅ return error as well
    }
  };
}


export function getCarRentServices() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url_Backend}/car/listServices`,);

      dispatch(
        slice.actions.getCarRentSuccess(response.data)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPopularAttractionServices() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url_Backend}/car/listServices`,);

      dispatch(
        slice.actions.getPopularAttractionSuccess(response.data)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getFleetCars(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${url_Backend}/car/carFleetsList`,
        obj
      );
      dispatch(slice.actions.fleetCarsSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getOurFleet() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url_Backend}/car/carFleetsList`,);

      dispatch(
        slice.actions.getOurFleetSuccess(response.data)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}


export function getBannerImagesList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.get(`${url_Backend}/common/getMainBanners`,);
      dispatch(
        slice.actions.getBannerImageListSuccess(response.data)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getRelatedProducts(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url_Backend}/common/relatedProducts`, obj);

      dispatch(
        slice.actions.getRelatedProductsSuccess(response.data)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getOurServiceList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      // const response = await axiosInstance.get(`${url_Backend}/common/ourServiceList`);
      const response = await axiosInstance.get(`${url_Backend}/common/ourServiceListForWeb`);

      dispatch(
        slice.actions.getOurServiceListSuccess(response.data)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPackageList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.get(`${url_Backend}/chauffeur/packages`);

      dispatch(
        slice.actions.getPackageListSuccess(response.data)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getChauffeurEnquiry(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url_Backend}/chauffeur/enquiry`, data);

      dispatch(
        slice.actions.getChauffeurEnquirySuccess(response.data)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getInvestmentEnquiry(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url_Backend}/investment/enquiry`, data);

      dispatch(
        slice.actions.getInvestmentEnquirySuccess(response.data)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getOurFleetsListNew() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.get(`${url_Backend}/chauffeur/getOurFleets`);

      dispatch(
        slice.actions.getOurFleetsListNewSuccess(response.data)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPrivateJetList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.get(`${RSL_BACKEND_URL}/jet/list`);

      dispatch(
        slice.actions.getPrivateJetListSuccess(response.data)
      );
    } catch (error) {
      dispatch(
        slice.actions.getPrivateJetListSuccess(error)
      );
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPrivateJetListNew(params = {}) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      // build query string from params (ignores null/undefined)
      const queryString = qs.stringify(params, { skipNulls: true });

      const response = await axiosInstance.get(
        `${RSL_BACKEND_URL}/jet/list${queryString ? `?${queryString}` : ""}`
      );

      dispatch(slice.actions.getPrivateJetListNewSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPrivateJetAdd(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${RSL_BACKEND_URL}/jet/enquiry`, data);

      dispatch(
        slice.actions.getPrivateJetAddSuccess(response?.data)
      );
    } catch (error) {
      dispatch(
        slice.actions.getPrivateJetAddSuccess(error?.response?.data || error)
      );
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getBookARidePage() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.get(`${RSL_BACKEND_URL}/trip/getBookARidePage`);

      dispatch(
        slice.actions.getBookARidePageSuccess(response.data)
      );
    } catch (error) {
      dispatch(
        slice.actions.getBookARidePageSuccess(error?.response?.data || error)
      );
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getActiveSubscriptionPlans() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.get(`${RSL_BACKEND_URL}/webBooker/listActivePlanWithFares`);

      dispatch(
        slice.actions.getActiveSubscripitonPlanSuccess(response.data)
      );
    } catch (error) {
      dispatch(
        slice.actions.getActiveSubscripitonPlanSuccess(error?.response.data || error)
      );
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getCarModels(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${RSL_ADMIN_BACKEND_URL}/newBooking/allCarMakeAndCategory`, obj);

      dispatch(
        slice.actions.getAllCarModelsSuccess(response.data)
      );
    } catch (error) {
      dispatch(
        slice.actions.getAllCarModelsSuccess(error?.response.data || error)
      );
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function validateLocation(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${RSL_BACKEND_URL}/webBooker/validatePickupInsideSubscriptionZones`, obj);

      dispatch(
        slice.actions.getLocationValidationSuccess(response.data)
      );
    } catch (error) {
      dispatch(
        slice.actions.getLocationValidationSuccess(error?.response.data || error)
      );
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getFare(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${RSL_ADMIN_BACKEND_URL}/newBooking/getFare`, obj);

      dispatch(
        slice.actions.getTripFareSuccess(response.data)
      );
    } catch (error) {
      dispatch(
        slice.actions.getTripFareSuccess(error?.response.data || error)
      );
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function createEnquiry(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${RSL_BACKEND_URL}/webBooker/createSubscriptionEnquiry`, obj);
      dispatch(
        slice.actions.getCreateEnquirySuccess(response?.data)
      );
    } catch (error) {
      dispatch(
        slice.actions.getCreateEnquirySuccess(error?.response?.data || error)
      );
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}


export function getActivitiesBlogs(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${RSL_ADMIN_BACKEND_URL}/activityBlogs/list`, obj);

      dispatch(
        slice.actions.getActivitiesBlogsListSuccess(response.data)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

//packages
export function getPackageCategoriesList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.get(`${RSL_ADMIN_BACKEND_URL}/activityBlogs/getPackageCategory`,);

      dispatch(
        slice.actions.getPackageCategoriesListSuccess(response.data)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}


export function getPackagePopularListServices(serviceType = 6) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url_Backend}/common/popularPackages`, {
        serviceType: serviceType
      });

      dispatch(
        slice.actions.getPackagePopularListSuccess(response.data)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}


export function getFutureBookingList(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${RSL_BACKEND_URL}/trip/futureBooking`, obj);
      dispatch(
        slice.actions.getFutureBookingListSuccess(response.data)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}


export function getTripUpdate(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${RSL_BACKEND_URL}/trip/getTripUpdate`, obj);
      dispatch(
        slice.actions.getFutureTripUpdateSuccess(response.data)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getTrustedPartners() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url_Backend}/blog/partnersList`);
      dispatch(
        slice.actions.getTrustedPartnersSuccess(response.data)
      );
    } catch (error) {
      console.error(error);
      dispatch(
        slice.actions.getTrustedPartnersSuccess(error?.response?.data ?? error)
      );
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getTopActivites() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.get(`${RSL_BACKEND_URL}/investment/getTopActivities`);
      dispatch(
        slice.actions.getTopActivitesSuccess(response.data)
      );
    } catch (error) {
      console.error(error);
      dispatch(
        slice.actions.getTopActivitesSuccess(error?.response?.data ?? error)
      );
      dispatch(slice.actions.hasError(error));
    }
  };
}